import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const RESIDENTIALPRICEDIFFINVANY_LAYER_ID = 'residentialPriceDiffInvAnyLayer';

const layerConfig = {
  title: 'Residential Price Difference',
};

function ResidentialPriceDiffInvAnyLayer() {
  const dispatch = useDispatch();
  const { residentialPriceDiffInvAnyLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, residentialPriceDiffInvAnyLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (residentialPriceDiffInvAnyLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: RESIDENTIALPRICEDIFFINVANY_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: residentialPriceDiffInvAnyLayer.visible,
      opacity: residentialPriceDiffInvAnyLayer.opacity,
      getFillColor: colorBins({
        attr: 'residential_price_diff',
        domain: [-188618, -277.25, -44.25, 717.35, 982.63, 1294.06, 259250],
        colors: [
          [178, 34, 34],
          [255, 0, 0],
          [255, 102, 102],
          [255, 204, 204],
          [224, 224, 255],
          [153, 204, 255],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: RESIDENTIALPRICEDIFFINVANY_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['residential_price_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default ResidentialPriceDiffInvAnyLayer;
